module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("© Copyright " + _vm._s(_vm.year) + "\n          "), _vm._m(0), _vm._v(" All rights reserved.\n        ")]), _vm._v(" "), _c('p', [_vm._v("1945 Camino Vida Roble, Carlsbad, CA 92008")])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "http://www.novaassure.com"
    }
  }, [_vm._v("Nova Assure")]), _vm._v(".\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('p', [_vm._v("Toll free "), _c('a', {
    attrs: {
      "href": "tel:#1-800-734-9885"
    }
  }, [_vm._v("#1-800-734-9885")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73b9e5b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = 1162
// module chunks = 2